// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-module-project {
  background-color: rgb(255, 124, 255);
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.manage-module-project h2 {
  color: white;
}

.project-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  justify-content: space-between; /* Adjust spacing between cards */
}

.project-card {
  background-color: rgb(255, 255, 255);
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 20px;
  width: 500px;
}

/* Apply styles for screens smaller than 768px */
@media screen and (max-width: 768px) {
  .project-card {
    width: calc(50% - 10px); /* Show two cards in a row */
  }
}

/* Apply styles for screens smaller than 576px */
@media screen and (max-width: 576px) {
  .project-card {
    width: 100%; /* Show one card in a row */
  }
}

.edit-form {
  margin-top: 20px;
}

.edit-form input,
.edit-form textarea {
  display: block;
  margin-bottom: 10px;
  width: 100%;
}

.mybuttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  color: blanchedalmond;
}

.buttoninz {
  color: white;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
}

.aqua-button {
  background-color: rgb(54, 168, 168);
}

.update-button {
  margin-right: 10px;
  background-color: rgb(54, 168, 168);
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/ManageContent/managecontentforms/managecontentstyle/ManageModuleProject.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,8BAA8B,EAAE,iCAAiC;AACnE;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA,gDAAgD;AAChD;EACE;IACE,uBAAuB,EAAE,4BAA4B;EACvD;AACF;;AAEA,gDAAgD;AAChD;EACE;IACE,WAAW,EAAE,2BAA2B;EAC1C;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;AACrC","sourcesContent":[".manage-module-project {\n  background-color: rgb(255, 124, 255);\n  padding: 20px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n}\n\n.manage-module-project h2 {\n  color: white;\n}\n\n.project-list {\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 20px;\n  justify-content: space-between; /* Adjust spacing between cards */\n}\n\n.project-card {\n  background-color: rgb(255, 255, 255);\n  border-radius: 4px;\n  padding: 20px;\n  margin-bottom: 20px;\n  width: 500px;\n}\n\n/* Apply styles for screens smaller than 768px */\n@media screen and (max-width: 768px) {\n  .project-card {\n    width: calc(50% - 10px); /* Show two cards in a row */\n  }\n}\n\n/* Apply styles for screens smaller than 576px */\n@media screen and (max-width: 576px) {\n  .project-card {\n    width: 100%; /* Show one card in a row */\n  }\n}\n\n.edit-form {\n  margin-top: 20px;\n}\n\n.edit-form input,\n.edit-form textarea {\n  display: block;\n  margin-bottom: 10px;\n  width: 100%;\n}\n\n.mybuttons {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 20px;\n  color: blanchedalmond;\n}\n\n.buttoninz {\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  cursor: pointer;\n}\n\n.aqua-button {\n  background-color: rgb(54, 168, 168);\n}\n\n.update-button {\n  margin-right: 10px;\n  background-color: rgb(54, 168, 168);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
